import React from 'react';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import AddManualExperienceLocationForm from '~/components/Content/ManualExperienceLocations/AddManualExperienceLocationForm';
import { ManualExperienceLocation } from '~/components/Content/ManualExperienceLocations/Columns';

type props = {
  open: boolean;
  onClose: () => void;
  data?: Array<ManualExperienceLocation>;
};

function AddManualExperienceLocationModal({ open, onClose, data }: props) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Add Manual Experience Location</DialogTitle>
      <DialogContent>
        <AddManualExperienceLocationForm onClose={onClose} data={data} />
      </DialogContent>
    </Dialog>
  );
}

export default AddManualExperienceLocationModal;
